import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import AdminRoutes from "Routes/Components/Admin";

import { UsePaginatedFetch } from "Hooks/UsePaginatedFetch";

import Button from "Components/Admin/Buttons";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import Select from "Components/Admin/Form/Select";
import Loading from "Components/Admin/Loading";
import Section from "Components/Admin/Section";
import Table from "Components/Admin/Table";
import GetIcon from "Components/Global/Icons";

import { columns, downloadColumns } from "./columns";
import * as S from "./styles";

const ListNotifications = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});

  const cancelRequest = useRef(false);

  const {
    setStartFetch,
    progress,
    requestInProgress,
    firstResponseReceived,
    data,
  } = UsePaginatedFetch({
    method: "post",
    path: "/notifications/list-notifications",
    body: { filters: { ...formData } },
    responseAccessor: "notifications",
    pageSize: 1000,
    cancelRequest: cancelRequest,
  });

  const methods = useForm({
    defaultValues: {
      id: "",
      title: "",
      status: "",
      automatic: "",
      levels: "",
    },
  });

  const { register } = methods;

  return (
    <Section>
      <S.SectionWrapper>
        <S.Wrapper>
          <FormWrapper
            {...methods}
            submit={
              !requestInProgress
                ? (data) => {
                    setFormData(data);
                    setStartFetch(true);
                  }
                : null
            }
          >
            <Input
              {...register("id")}
              label="ID da Notificação"
              placeholder="ID"
              type="text"
            />

            <Input
              {...register("title")}
              label="Título da Notificação"
              placeholder="Título"
              type="text"
            />

            <Select
              name="status"
              label="Status"
              placeholder={"Selecione um status"}
              options={[
                { value: null, label: "Todas" },
                { value: "active", label: "Ativas" },
                { value: "inactive", label: "Inativas" },
              ]}
            />

            <Select
              name="automatic"
              label="Automática"
              placeholder={"Selecione"}
              options={[
                { value: null, label: "Todas" },
                { value: "true", label: "Sim" },
                { value: "false", label: "Não" },
              ]}
            />

            <Select
              name="levels"
              label="Níveis"
              placeholder={"Selecione os Níveis"}
              options={[
                { value: null, label: "Todas" },
                { value: "regular", label: "Regular" },
                { value: "toast", label: "Toast" },
                { value: "email", label: "E-mail" },
                { value: "popup", label: "Pop-up" },
              ]}
            />

            <Button
              type="submit"
              text={
                requestInProgress
                  ? progress
                    ? `Carregando ${progress}%...`
                    : "Carregando..."
                  : !methods.formState?.isDirty
                    ? "Buscar Todos"
                    : "Buscar"
              }
            />
            {requestInProgress && (
              <Button
                text="Cancelar requisição"
                variant="critical"
                onClick={() => {
                  cancelRequest.current = true;
                }}
              />
            )}
          </FormWrapper>

          {requestInProgress && !firstResponseReceived ? (
            <Loading />
          ) : (
            <Table
              name="Notificações"
              data={data}
              columns={[
                ...columns,
                {
                  Header: "Ações",
                  accessor: "actions",
                  noSearch: true,
                  width: "70px",
                  Cell: ({ cell }) => (
                    <S.Actions>
                      <GetIcon
                        name="Edit"
                        onClick={() => {
                          const row = cell.row.original;
                          navigate(
                            AdminRoutes.NotificationDetails.path.replace(
                              ":id",
                              row.id,
                            ),
                          );
                        }}
                      />
                    </S.Actions>
                  ),
                },
              ]}
              downloadColumns={downloadColumns}
              disableDownloadButton={requestInProgress}
            />
          )}
        </S.Wrapper>
      </S.SectionWrapper>
    </Section>
  );
};

export default ListNotifications;
